const BASE = process.env.REACT_APP_BACKEND_URL;

export const apiFetch = async (path, { method = "GET", body, formData } = {}) => {
  const headers = {};
  const token = localStorage.getItem("spt_admin_token");
  if (token) headers["Authorization"] = `Bearer ${token}`;
  let payload;
  if (formData) {
    payload = formData;
  } else if (body !== undefined) {
    headers["Content-Type"] = "application/json";
    payload = JSON.stringify(body);
  }
  const res = await fetch(`${BASE}/api${path}`, { method, headers, body: payload, credentials: "include" });
  if (!res.ok) {
    let msg = `Request failed (${res.status})`;
    try {
      const d = await res.json();
      if (typeof d.detail === "string") msg = d.detail;
      else if (Array.isArray(d.detail)) msg = d.detail.map((e) => e.msg || "").join(" ");
    } catch {}
    throw new Error(msg);
  }
  return res.json();
};

export const fetchFileBlobUrl = async (path) => {
  const token = localStorage.getItem("spt_admin_token");
  const res = await fetch(`${BASE}/api${path}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    credentials: "include",
  });
  if (!res.ok) throw new Error("Could not load file");
  return URL.createObjectURL(await res.blob());
};
